
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/refer",
      function () {
        return require("private-next-pages/qmee/refer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/refer"])
      });
    }
  